import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const authHooks = {
  useRequestOtp: () => {
    const mutation = trpc.auth.requestOtp.useMutation({
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message:
            error.message || 'Kertakirjautumiskoodin lähetys epäonnistui',
          color: 'red',
        })
      },
    })

    return mutation
  },

  useVerifyOtp: () => {
    const mutation = trpc.auth.verifyOtp.useMutation({
      onSuccess: () => {
        notifications.show({
          title: 'Tervetuloa!',
          message: 'Kirjautuminen onnistui',
          color: 'green',
        })
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Virheellinen kertakirjautumiskoodi',
          color: 'red',
        })
      },
    })

    return mutation
  },

  useLogout: () => {
    const mutation = trpc.auth.logout.useMutation({
      onSuccess: () => {
        window.location.href = '/'
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Uloskirjautuminen epäonnistui',
          color: 'red',
        })
      },
    })

    return mutation
  },

  useMe: () => {
    return trpc.user.me.useQuery()
  },

  useGoogleLogin: () => {
    return trpc.auth.googleLogin.useQuery(
      { app: 'resident' },
      { enabled: false },
    )
  },

  useGoogleCallback: () => {
    const mutation = trpc.auth.googleCallback.useMutation({
      onSuccess: () => {
        notifications.show({
          title: 'Tervetuloa!',
          message: 'Kirjautuminen onnistui',
          color: 'green',
        })
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Google-kirjautuminen epäonnistui',
          color: 'red',
        })
      },
    })

    return mutation
  },
}
